import React from 'react';
import {ReactComponent as AdminTypeSvg} from "../assets/svg/admin-type.svg";
import {ReactComponent as TeacherTypeSvg} from "../assets/svg/teacher-type.svg";
import {ReactComponent as StudentTypeSvg} from "../assets/svg/student-type.svg";
import {ReactComponent as GuardianTypeSvg} from "../assets/svg/guardian-type.svg";
import {ReactComponent as TeacherBorderSvg} from "../assets/svg/teacher-border.svg";
import {ReactComponent as StudentBorderSvg} from "../assets/svg/student-border.svg";
import {ReactComponent as GuardianBorderSvg} from "../assets/svg/guardian-border.svg";
import type { AccountTypeValue } from '../types';
export type { AccountTypeValue };

export class AccountType {
    static STUDENT = "student" as const;
    static GUARDIAN = "guardian" as const;
    static ADMIN = "admin" as const;
    static TEACHER = "teacher" as const;

    type: AccountTypeValue;

    constructor(type: AccountTypeValue) {
        this.type = type;
    }

    getLogo(): React.ReactElement {
        switch (this.type) {
            case AccountType.STUDENT:
                return <StudentTypeSvg/>;
            case AccountType.GUARDIAN:
                return <GuardianTypeSvg/>;
            case AccountType.ADMIN:
                return <AdminTypeSvg/>;
            case AccountType.TEACHER:
                return <TeacherTypeSvg/>;
            default:
                return <></>;
        }
    }

    getBorderLogoString(): React.FunctionComponent<React.SVGProps<SVGSVGElement>> | null {
        switch (this.type) {
            case AccountType.STUDENT:
                return StudentBorderSvg;
            case AccountType.GUARDIAN:
                return GuardianBorderSvg;
            case AccountType.TEACHER:
                return TeacherBorderSvg;
            default:
                return null;
        }
    }
}
